import { render, staticRenderFns } from "./SliderBanner.vue?vue&type=template&id=c2aaf098&scoped=true&"
import script from "./SliderBanner.vue?vue&type=script&lang=js&"
export * from "./SliderBanner.vue?vue&type=script&lang=js&"
import style0 from "./SliderBanner.vue?vue&type=style&index=0&id=c2aaf098&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2aaf098",
  null
  
)

export default component.exports